import {getDefaultModules} from'~/webpack/require-context'

const context = require.context(`containers/`, true, /\/routes\/.*\.js$/)
const routes = getDefaultModules(context).values()
export default routes
// console.log({routes})

